module.exports = __webpack_public_path__ + "static/media/categories.19458af8.png";